interface UndoConfirmPopupProps {
  undoType: 'rally' | 'server';
  onConfirm: () => void;
  onCancel: () => void;
}

export default function UndoConfirmPopup({ undoType, onConfirm, onCancel }: UndoConfirmPopupProps) {
  const isRally = undoType === 'rally';
  const title = isRally ? 'Undo Last Rally' : 'Undo Server Selection';
  const message = isRally
    ? 'This will remove the last rally and restore the previous score, serving team, server, and rotation. Are you sure?'
    : 'This will clear the current server selection and return to the Server Selection screen. The score and rally will be kept. Are you sure?';
  const confirmLabel = isRally ? 'Yes, Undo Rally' : 'Yes, Undo Server';
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-50">
      <div className="bg-surface border border-border rounded-xl p-6 max-w-sm w-full animate-fade-in">
        <div className="text-center">
          <div className="w-12 h-12 rounded-full bg-warning/20 flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-warning" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-text-primary mb-2">{title}</h2>
          <p className="text-text-secondary mb-6">
            {message}
          </p>
          <div className="space-y-3">
            <button
              onClick={onConfirm}
              className="btn-primary bg-error text-white font-bold py-3 w-full"
            >
              {confirmLabel}
            </button>
            <button
              onClick={onCancel}
              className="btn-secondary w-full"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
